// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-dialog {\n  margin-top: 0.052083rem !important;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 11>"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC","file":"changePwd.vue","sourcesContent":[".el-dialog {\n  margin-top: 0.052083rem !important;\n}"]}]);
// Exports
module.exports = exports;
